/**
 * Produkt-Tabs — selbstkonfigurierend, mit zwei Darstellungen:
 *
 *   Desktop (≥750px): Pillen-Leiste, ein Klick zeigt genau einen Bereich.
 *   Mobil   (<750px): Accordion — jede Rubrik als aufklappbare Zeile
 *                     (wie bei badheizkoerper.shop), erste Rubrik offen.
 *
 * Die Leiste/Köpfe bauen sich aus den tatsächlich vorhandenen
 * Inhalts-Blöcken selbst auf. Panels werden NUR als direkte Geschwister
 * (eine Wrapper-Ebene erlaubt) gesucht — nie tief, sonst greifen Klassen
 * aus Produktbeschreibungs-HTML ins System.
 *
 * Ohne JavaScript: keine Leiste, keine Köpfe, alle Bereiche sichtbar.
 *
 * Außerdem hier: Wisch-Hinweis für horizontal scrollende Tabellen
 * (.hlt__scroll / .vgl__scroll) auf Mobilgeräten.
 */
(function () {
  'use strict';

  var MOBIL = window.matchMedia('(max-width: 749px)');

  /* Icons (Strich-Stil, 24er Raster) — sitzen links vom Tab-Titel bzw. im Accordion-Kopf */
  var SVG_START = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">';
  var ICONS = {
    beschreibung: SVG_START + '<path d="M4 6h16M4 12h16M4 18h10"/></svg>',
    vorteile: SVG_START + '<path d="m12 3 2.4 1.9 3-.3.6 3 2.7 1.5-1.3 2.9 1.3 2.9-2.7 1.5-.6 3-3-.3L12 21l-2.4-1.9-3 .3-.6-3L3.3 14.9l1.3-2.9-1.3-2.9L6 7.6l.6-3 3 .3L12 3Z"/><path d="m9 12 2 2 4-4"/></svg>',
    leistung: SVG_START + '<path d="M14 14.8V5a2 2 0 1 0-4 0v9.8a4 4 0 1 0 4 0Z"/><path d="M12 9v6"/></svg>',
    technik: SVG_START + '<path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9l-6-6Z"/><path d="M14 3v6h6M8 13h8M8 17h6"/></svg>',
    rechner: SVG_START + '<rect x="5" y="3" width="14" height="18" rx="2"/><path d="M8.5 7.5h7"/><path d="M8.5 12h.01M12 12h.01M15.5 12h.01M8.5 16h.01M12 16h.01M15.5 16h.01"/></svg>',
    fragen: SVG_START + '<circle cx="12" cy="12" r="9"/><path d="M9.6 9.6a2.5 2.5 0 1 1 3.6 2.2c-.8.5-1.2 1-1.2 1.8"/><path d="M12 17h.01"/></svg>',
    alles: SVG_START + '<rect x="4" y="4" width="7" height="7" rx="1.5"/><rect x="13" y="4" width="7" height="7" rx="1.5"/><rect x="4" y="13" width="7" height="7" rx="1.5"/><rect x="13" y="13" width="7" height="7" rx="1.5"/></svg>'
  };

  /* Reihenfolge laut User 24.09.: Beschreibung, Alle Vorteile, Technische Daten,
     Heizleistung & Vergleich, Watt-Rechner, Fragen (+ Alles auf einen Blick).
     Die Blockreihenfolge in templates/product.json ist identisch, damit das
     mobile Accordion dieselbe Abfolge zeigt. */
  var DEFINITION = [
    { klassen: ['pbesch'], label: 'Beschreibung', icon: ICONS.beschreibung },
    { klassen: ['lu'], label: 'Alle Vorteile', icon: ICONS.vorteile },
    /* Downloads (.pdl) laufen im Tab „Technische Daten“ mit */
    { klassen: ['td', 'pdl'], label: 'Technische Daten', einzeln: { td: 'Technische Daten', pdl: 'Downloads' }, icon: ICONS.technik },
    { klassen: ['hlt', 'vgl'], label: 'Heizleistung & Vergleich', einzeln: { hlt: 'Heizleistung', vgl: 'Vergleich' }, icon: ICONS.leistung },
    { klassen: ['hlr'], label: 'Watt-Rechner', icon: ICONS.rechner },
    { klassen: ['pfaq'], label: 'Fragen', icon: ICONS.fragen }
  ];

  function direktesPanel(wurzel, klasse) {
    var p = wurzel.querySelector(':scope > .' + klasse);
    if (!p) p = wurzel.querySelector(':scope > * > .' + klasse);
    if (p && p.textContent.trim().length > 0) return p;
    return null;
  }

  function einrichten(container) {
    if (container.dataset.tabsBereit === '1') return;
    var leiste = container.querySelector('.ptabs__leiste');
    if (!leiste) return;
    var wurzel = container.parentElement || document.body;

    var gruppen = [];
    DEFINITION.forEach(function (def) {
      var panels = [];
      var gefunden = [];
      def.klassen.forEach(function (k) {
        var p = direktesPanel(wurzel, k);
        if (p) { panels.push(p); gefunden.push(k); }
      });
      if (!panels.length) return;
      var label = def.label;
      if (def.einzeln && gefunden.length === 1) label = def.einzeln[gefunden[0]] || label;
      gruppen.push({ label: label, panels: panels, icon: def.icon || '' });
    });

    if (gruppen.length < 2) {
      container.setAttribute('hidden', '');
      container.dataset.tabsBereit = '1';
      return;
    }

    var alle = [];
    gruppen.forEach(function (g) {
      g.panels.forEach(function (p) { if (alle.indexOf(p) === -1) alle.push(p); });
    });

    var tabGruppen = gruppen.concat([{ label: 'Alles auf einen Blick', panels: alle, alles: true, icon: ICONS.alles }]);

    alle.forEach(function (p, i) {
      p.setAttribute('role', 'tabpanel');
      if (!p.id) p.id = 'ptab-panel-' + i;
    });

    /* ---------- Desktop-Leiste ---------- */
    leiste.innerHTML = '';
    var knoepfe = tabGruppen.map(function (g) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ptabs__tab' + (g.alles ? ' ptabs__tab--alles' : '');
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-controls', g.panels.map(function (p) { return p.id; }).join(' '));
      b.innerHTML = g.icon + '<span class="ptabs__label"></span>';
      b.querySelector('.ptabs__label').textContent = g.label;
      leiste.appendChild(b);
      return b;
    });

    var aktIndex = 0;

    function zeige(index) {
      aktIndex = index;
      var aktiv = tabGruppen[index];
      alle.forEach(function (p) {
        p.classList.toggle('ptabs-panel--aus', aktiv.panels.indexOf(p) === -1);
      });
      knoepfe.forEach(function (k, i) {
        var an = i === index;
        k.classList.toggle('is-active', an);
        k.setAttribute('aria-selected', String(an));
        k.setAttribute('tabindex', an ? '0' : '-1');
      });
    }

    knoepfe.forEach(function (k, i) {
      k.addEventListener('click', function () { zeige(i); });
      k.addEventListener('keydown', function (e) {
        var ziel = null;
        if (e.key === 'ArrowRight') ziel = (i + 1) % knoepfe.length;
        if (e.key === 'ArrowLeft') ziel = (i - 1 + knoepfe.length) % knoepfe.length;
        if (e.key === 'Home') ziel = 0;
        if (e.key === 'End') ziel = knoepfe.length - 1;
        if (ziel === null) return;
        e.preventDefault();
        zeige(ziel);
        knoepfe[ziel].focus();
      });
    });

    /* ---------- Mobile Accordion-Köpfe ---------- */
    gruppen.forEach(function (g, i) {
      var kopf = document.createElement('button');
      kopf.type = 'button';
      kopf.className = 'ptabs-acc';
      kopf.setAttribute('aria-expanded', 'false');
      kopf.setAttribute('aria-controls', g.panels.map(function (p) { return p.id; }).join(' '));
      kopf.innerHTML = '<span class="ptabs-acc__icon" aria-hidden="true">' + g.icon + '</span><span class="ptabs-acc__label"></span><span class="ptabs-acc__chev" aria-hidden="true"></span>';
      kopf.querySelector('.ptabs-acc__label').textContent = g.label;
      g.panels[0].parentNode.insertBefore(kopf, g.panels[0]);
      g.kopf = kopf;
      kopf.addEventListener('click', function () {
        var offen = !kopf.classList.contains('is-open');
        kopf.classList.toggle('is-open', offen);
        kopf.setAttribute('aria-expanded', String(offen));
        g.panels.forEach(function (p) { p.classList.toggle('ptabs-acc-offen', offen); });
        /* Wisch-Hinweise neu messen — beim Aufklappen war die Breite vorher 0 */
        window.dispatchEvent(new Event('resize'));
      });
      if (i === 0) {
        kopf.classList.add('is-open');
        kopf.setAttribute('aria-expanded', 'true');
        g.panels.forEach(function (p) { p.classList.add('ptabs-acc-offen'); });
      }
    });

    /* ---------- Moduswechsel ---------- */
    function wendeModusAn() {
      if (MOBIL.matches) {
        container.setAttribute('hidden', '');
        alle.forEach(function (p) { p.classList.remove('ptabs-panel--aus'); });
        wurzel.classList.add('ptabs-acc-bereit');
      } else {
        wurzel.classList.remove('ptabs-acc-bereit');
        container.removeAttribute('hidden');
        zeige(aktIndex);
      }
    }

    if (MOBIL.addEventListener) MOBIL.addEventListener('change', wendeModusAn);
    else MOBIL.addListener(wendeModusAn);
    wendeModusAn();

    container.dataset.tabsBereit = '1';
  }

  /* ---------- Wisch-Hinweis für breite Tabellen ---------- */
  function wischHinweise() {
    [].forEach.call(document.querySelectorAll('.hlt__scroll, .vgl__scroll'), function (box) {
      if (box.dataset.wischBereit) return;
      box.dataset.wischBereit = '1';
      function pruefe() {
        var mehr = box.scrollWidth - box.clientWidth > 24 && box.scrollLeft < 16;
        box.classList.toggle('hat-mehr', mehr);
      }
      box.addEventListener('scroll', pruefe, { passive: true });
      window.addEventListener('resize', pruefe);
      pruefe();
    });
  }

  function start() {
    [].forEach.call(document.querySelectorAll('[data-produkt-tabs]'), einrichten);
    wischHinweise();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Im Theme-Editor werden Blöcke neu gerendert
  document.addEventListener('shopify:section:load', function () {
    [].forEach.call(document.querySelectorAll('[data-produkt-tabs]'), function (c) {
      delete c.dataset.tabsBereit;
    });
    start();
  });
})();
